import { EntityItem, SearchQuery } from '@texas/components/agent/types';
import { httpClient } from '../httpClient/httpClient';

export interface CreateConceptRequest {
  name: string;
}
export interface Concept {
  id: number;
  name: string;
  archived: string | null;
  customerId: number;
  folderId: number;
}

interface ConceptSlim {
  id: number;
  name: string;
  customerId: number;
  customerName: string;
}

export interface UpdateConceptRequest {
  name: string;
}

export const conceptsApi = {
  addConcept: (customerId: number, data: CreateConceptRequest) =>
    httpClient.post<Concept>(`concepts/create/${customerId}`, { data }),
  filterConcepts: (query: SearchQuery) =>
    httpClient.post<EntityItem[]>(`concepts/filter`, { data: query }),
  getSlim: (id: number) => httpClient.get<ConceptSlim>(`customers/${id}/slim`),
  update: (conceptId: number, data: UpdateConceptRequest) =>
    httpClient.put<Concept>(`concepts/${conceptId}`, { data }),
  archive: (conceptId: number) =>
    httpClient.put<Concept>(`concepts/${conceptId}/archive`),
  restore: (conceptId: number) =>
    httpClient.put<Concept>(`concepts/${conceptId}/restore`),
  get: (id: number) => httpClient.get<Concept>(`concepts/${id}`),
};
